import { getAllTags } from "api/tags";

const allConfigurationApiConfig = {
  getAllTags
};

export default allConfigurationApiConfig;